import { render, staticRenderFns } from "./CreateSucursal.vue?vue&type=template&id=2abfdf37&"
import script from "./CreateSucursal.vue?vue&type=script&lang=js&"
export * from "./CreateSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports